import { createApiRef } from '@backstage/core-plugin-api';
import type { AwsHealthMonitorResults } from '@internal/plugin-aws-health-monitor-common';

export interface AwsHealthMonitorApi {
  getHealthMonitorResults(): Promise<AwsHealthMonitorResults>;
}

export const awsHealthMonitorApiRef = createApiRef<AwsHealthMonitorApi>({
  id: 'plugin.aws-health-monitor.service',
});

export type { AwsHealthMonitorResults };
